import React from 'react'
import SignInHeader from '../../components/signIn/SignInHeader'
import SignUpForm from '../../components/SignUp/SignUpForm'
import SignUpFooter from '../../components/SignUp/SignUpFooter'
import SEO from '../../components/SEO/SEO'

const SignUp = () => {
  return (
    <>
    <SEO title="Create Account" noIndex={true} />
    <div className="flex justify-center items-center min-h-screen">
        <div className="bg-tertiary rounded-[50px] mt-[76px] mb-32 p-6 sm:p-8 shadow-lg w-full max-w-[95%] md:max-w-[1039px] h-auto relative">
          <SignInHeader />
          <SignUpForm />
          <SignUpFooter />
        </div>
      </div>
    </>
  )
}

export default SignUp